module.exports = __webpack_public_path__ + "img/emot-passport-logo.6e41ebfa.png";